export interface Screenshot {
  name: string;
  image: string;
  fit?: 'cover' | 'contain';
}

export interface WorkingCategory {
  id: string;
  icon: string;
  screenshots: Screenshot[];
}

export interface WorkingTab {
  name: string;
  icon: string;
  categoryId: string;
}

export type WorkingTabs = Record<string, WorkingTab>;

// POS and customer categories use real per-screen screenshots. Rider and
// partner categories still reuse placeholder marketing art — swap the
// `image` paths below when those app screenshots land.
export const HOME_WORKING_DATA: WorkingCategory[] = [
  {
    id: 'pos',
    icon: 'monitor',
    screenshots: [
      { name: 'Home', image: '/images/home-pos.png', fit: 'cover' },
      { name: 'Register', image: '/images/register.png', fit: 'cover' },
      { name: 'Payment', image: '/images/payment-pos.png', fit: 'cover' },
      { name: 'Product View', image: '/images/product-pos.png', fit: 'cover' },
      { name: 'Checkout', image: '/images/checkout-pos.png', fit: 'cover' },
    ],
  },
  {
    id: 'customer',
    icon: 'phone',
    screenshots: [
      { name: 'Home', image: '/images/home.png', fit: 'cover' },
      { name: 'Search', image: '/images/search.png', fit: 'cover' },
      { name: 'Cart', image: '/images/cart.png' },
      { name: 'Checkout', image: '/images/checkout.png' },
      { name: 'Order Details', image: '/images/order-detail.png' },
    ],
  },
  {
    id: 'rider',
    icon: 'bike',
    screenshots: [
      { name: 'Dashboard', image: '/images/dash-rider.png', fit: 'cover' },
      { name: 'Sessions', image: '/images/session.png', fit: 'cover' },
      { name: 'Wallet', image: '/images/wallet.png', fit: 'cover' },
      { name: 'Ledger', image: '/images/ledger.png', fit: 'cover' },
      { name: 'Support', image: '/images/support.png', fit: 'cover' },
    ],
  },
  {
    id: 'partner',
    icon: 'store',
    screenshots: [
      { name: 'Dashboard', image: '/images/dashboard.png', fit: 'cover' },
      { name: 'Store', image: '/images/store2.png', fit: 'cover' },
      { name: 'Overview', image: '/images/overview.png' },
      { name: 'Payout', image: '/images/payouts.png', fit: 'cover' },
    ],
  },
];

export const WORKING_DATA = {
  working: {
    workflowTitle: 'Screens',
    defaultIcon: 'monitor',
    tabs: {
      pos: { name: 'POS Desktop', icon: 'monitor', categoryId: 'pos' },
      customer: { name: 'Customer', icon: 'phone', categoryId: 'customer' },
      rider: { name: 'Rider', icon: 'bike', categoryId: 'rider' },
      partner: { name: 'Partner', icon: 'store', categoryId: 'partner' },
    } as WorkingTabs,
    altText: {
      workflowStep: 'OrderYaa app screen',
      modalImage: 'OrderYaa app screen, full size',
    },
    ariaLabels: {
      previousImage: 'Previous screen',
      nextImage: 'Next screen',
      closeModal: 'Close preview',
    },
  },
};
